import { render, staticRenderFns } from "./businnssSettled.vue?vue&type=template&id=21444756&scoped=true&"
import script from "./businnssSettled.vue?vue&type=script&lang=js&"
export * from "./businnssSettled.vue?vue&type=script&lang=js&"
import style0 from "./businnssSettled.vue?vue&type=style&index=0&id=21444756&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21444756",
  null
  
)

export default component.exports